"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  default: {
    root: {
      fontFamily: 'mrEaves',
      textTransform: 'uppercase'
    },
    icon: {},
    main: {}
  }
};
exports.default = _default;